// src/data/newsData.js

export const newsData = [
  {
    id: 1,
    date: "01",
    month: "DEC",
    year: "2025",
    title: "Nouvelle version de la Charte marocaine de l'expertise immobilière",
    excerpt:
      "La nouvelle version de la Charte marocaine de l'expertise immobilière a récemment été publiée, consolidant le cadre de référence national en matière de rigueur méthodologique, d'éthique professionnelle et de qualité des pratiques dans le domaine de l'évaluation et du conseil immobilier au Maroc.",
    image:
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=2000",
    content:
      "La nouvelle version de la Charte marocaine de l'expertise immobilière a récemment été publiée, consolidant le cadre de référence national en matière de rigueur méthodologique, d'éthique professionnelle et de qualité des pratiques dans le domaine de l'évaluation et du conseil immobilier au Maroc.\n\nDans ce cadre, la direction d'ATAA REALTY a pris part aux travaux d'élaboration de cette version, contribuant aux réflexions visant à renforcer l'alignement des pratiques nationales avec les standards internationaux et à promouvoir une culture de responsabilité et de structuration durable de la profession.",
    pdfUrl: "/charte-marocaine-2025.pdf",
    pdfDownloadName: "Charte-marocaine-expertise-immobiliere-2025.pdf",
    pdfTitle: "Charte de l'Expertise en Évaluation Immobilière — Édition 2025",
  },
];
